
    <div class="app-nav">
      <div class="wrapper">
        <a [routerLink]="[ '/schedule' ]" routerLinkActive="active">Schedule</a>
        <a [routerLink]="[ '/meals' ]" routerLinkActive="active">Meals</a>
        <a [routerLink]="[ '/workouts' ]" routerLinkActive="active">WorkOuts</a>
      </div>
    </div>
  